<template>
  <div class="sugestion-line-hint">
    <span class="text-small font-weight-bold text-exitos mr-1">
      <font-awesome-icon icon="bolt-lightning" size="xs" />
      Sugest.
    </span>
    <button
      v-for="(sugestion, index) in sugestions"
      :key="`${sugestion.value}-${index}`"
      type="button"
      variant="primary"
      class="bg-exitos custom bg-bagsis-10 text-exitos border-0 rounded-pill on-hover"
      :aria-pressed="modelValue === sugestion.value"
      @click="selectSugestion(sugestion.value)"
    >
      {{ sugestion.text }}
    </button>
  </div>
</template>

<script>
import { defineComponent, ref, shallowRef, watchEffect } from "vue";
import { useMouseInElement, useVModel } from "@vueuse/core";

function isStringOrNumber(value) {
  return ["string", "number"].includes(typeof value);
}

export default defineComponent({
  name: "SugestionLineHint",
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    sugestions: {
      type: Array,
      required: true,
      validator: (sugestions) =>
        sugestions.every(
          (sugestion) =>
            sugestion &&
            isStringOrNumber(sugestion.text) &&
            isStringOrNumber(sugestion.value)
        ),
    },
  },
  setup(props, { emit }) {
    const modelValue = useVModel(props, "value", emit, {
      eventName: "input",
    });

    function selectSugestion(value) {
      modelValue.value = value;
    }

    return {
      modelValue,
      selectSugestion,
    };
  },
});
</script>

<style scoped lang="scss">
.show {
  opacity: 1;
}

.hidden {
  opacity: 0;
}

.on-hover {
  &:hover {
    background-color: rgba(var(--exitos-rgb), 0.15) !important;
  }

  &:focus {
    outline-offset: 1px;
    outline-color: rgba(var(--exitos-rgb), 0.5) !important;
    background-color: rgba(var(--exitos-rgb), 0.15) !important;
  }
}
.sugestion-line-hint {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 0.675rem;
  gap: 0.25rem;
  margin-top: 0.25rem;
}

.sugestion-line-hint__option {
  appearance: none;
  background: transparent;
  border: 0;
  color: var(--primary);
  cursor: pointer;
  padding: 0 0.125rem;

  &:focus {
    outline: 1px dotted currentColor;
    outline-offset: 2px;
  }
}

.sugestion-line-hint__option--selected {
  font-weight: 600;
  text-decoration: none;
}
</style>
